/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 7/25/13
 * Time: 6:53 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("web-agent-templates/webAgentModule.tmpl");

    var MainLayout = {};
    LE.module("LEWebAgent", function (LEWebAgent, LE, Backbone, Marionette) {

        MainLayout = Marionette.Layout.extend({
            template:template,
            className: "wa",
            regions:{
                mainRegion:".webagent-main"
            }

        });

    });
    return MainLayout;
});